import styled from "@emotion/styled";
import { MDSSkeleton } from "@/mds";
import type { FC } from "react";

const SKELETON_ROW_COUNT = 5;

export const ImportLoadingSkeleton: FC = () => {
  return (
    <StyledSkeletonContainer data-test-id="import-loading-skeleton">
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
        <StyledSkeletonRow key={index} $opacity={index < 3 ? 1 : 0}>
          <StyledSkeletonIconContainer>
            <MDSSkeleton height={16} width={16} delay={index * 100} />
          </StyledSkeletonIconContainer>
          <StyledSkeletonContent>
            <MDSSkeleton height={20} width={480} delay={index * 100} />
            <MDSSkeleton height={16} width={200} delay={index * 100 + 50} />
          </StyledSkeletonContent>
        </StyledSkeletonRow>
      ))}
    </StyledSkeletonContainer>
  );
};

const StyledSkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 400px;
  padding-block: ${({ theme }) => theme.spacing["1"]};
`;

const StyledSkeletonRow = styled.div<{ $opacity: number }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["3"]};
  padding-inline: ${({ theme }) => theme.spacing["2"]};
  padding-block: ${({ theme }) => theme.spacing["0"]};
  min-height: 76px;
  opacity: ${({ $opacity }) => $opacity};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};

  &:last-child {
    border-bottom: none;
  }
`;

const StyledSkeletonIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 18px;
  padding-bottom: 12px;
  height: 76px;
  flex-shrink: 0;
`;

const StyledSkeletonContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
  flex: 1;
  min-width: 0;
  padding-block: ${({ theme }) => theme.spacing["4"]};
`;
